module.exports = __webpack_public_path__ + "img/icon24.e70d5a16.png";